'use client';

import ServiceContent from '@/components/services/ServiceContent';
import DomesticTransportationContent from '@/content/services/en/domestic-transportation.mdx';

export default function DomesticTransportationClient() {
    return (
        <ServiceContent>
            <DomesticTransportationContent />
        </ServiceContent>
    );
}
